<script setup>
import NextButton from 'dashboard/components-next/button/Button.vue';

const emit = defineEmits(['clear', 'change']);

const onClickClear = () => {
  emit('clear');
};

const onClickApply = () => {
  emit('change');
};
</script>

<template>
  <div
    class="sticky bottom-0 z-10 flex justify-between gap-2 border-t border-n-weak bg-n-surface-1 px-3 py-3 items-center"
  >
    <NextButton
      slate
      ghost
      sm
      :label="$t('DATE_PICKER.CLEAR_BUTTON')"
      @click="onClickClear"
    />
    <NextButton
      sm
      :label="$t('DATE_PICKER.APPLY_BUTTON')"
      @click="onClickApply"
    />
  </div>
</template>
